"use client";

const LABEL =
  "text-[12px] font-semibold uppercase leading-none tracking-wide text-[var(--theme-on-primary,#fff)]";

const HEAD_BASE =
  "kbv-sin-table-head box-border w-full bg-[var(--theme-primary)]";

export default function SinMatchHeader({ className = "" }) {
  return (
    <>
      <div
        className={[
          HEAD_BASE,
          "kbv-sin-table-grid kbv-sin-table-head-desktop hidden rounded-t-lg px-3 py-2 md:grid",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className={`${LABEL} flex min-w-0 items-center justify-center`}>Thời gian</div>
        <div className={`${LABEL} flex min-w-0 items-center`}>Trận đấu</div>
        <div className={`${LABEL} flex min-w-0 items-center justify-center`}>Kèo chấp</div>
        <div className={`${LABEL} flex min-w-0 items-center justify-center`}>Kèo Tài xỉu</div>
        <div className={`${LABEL} flex min-w-0 items-center justify-center`}>1X2</div>
        <div className={`${LABEL} flex min-w-0 items-center justify-center`}>Cược</div>
      </div>

      <div
        className={[
          HEAD_BASE,
          "kbv-sin-table-head-mobile rounded-t-lg py-2 md:hidden",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="kbv-sin-mobile-odds-grid kbv-sin-mobile-odds-grid--head">
          <span className="kbv-sin-mobile-odds-grid__ft" aria-hidden="true" />
          <span className={`kbv-sin-mobile-odds-grid__col ${LABEL} text-[10px] leading-tight sm:text-[11px]`}>
            Kèo Châu Á
          </span>
          <span className={`kbv-sin-mobile-odds-grid__col ${LABEL} text-[10px] leading-tight sm:text-[11px]`}>
            Kèo Tài xỉu
          </span>
          <span className={`kbv-sin-mobile-odds-grid__col ${LABEL} text-[10px] leading-tight sm:text-[11px]`}>
            Kèo 1x2
          </span>
        </div>
      </div>
    </>
  );
}
